import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  getByIdTableFailure, getByIdTableSuccess,
  updateTableFailure, updateTableSuccess,
  addTableFailure, addTableSuccess,
  deleteTableSuccess, deleteTableFailure,
  getTableSuccess,
  getTableFailure
} from '../../Actions';
import { api } from "../../Config/ApiInterface";

// GET tables
function* getTableListSaga(action) {
  try {
    const { page, limit, datetime=null } = action.payload || {};
    let params;
    if(datetime==undefined)
    {

       params = new URLSearchParams({ page, limit });
    }
    else
    {
       params = new URLSearchParams({ page, limit, datetime });

    }
    const hotel_id=localStorage.getItem('hotel_id')

    const response = yield call(api.post, `/tables/all?hotel_id=${hotel_id}&${params}`);
    if (response) {
      yield put(getTableSuccess(response.data));
    } else {
      yield put(getTableFailure(response.error || "Failed to fetch tables."));
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getTableFailure(error));
    // toast.error("Failed to fetch tables.");
  }
}

//add room type
function* addTableSaga(action) {
  try {
    const response = yield call(api.post, `/tables`, action.payload);
    if (response) {
      yield put(addTableSuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(addTableFailure(response.error || "Failed to add table."));
    }
  } catch (error) {
    yield put(addTableFailure(error));
    toast.error("Failed to add table.");
  }
}

//delete room type
function* deleteTableSaga(action) {
  try {
    const { id } = action.payload;
    const hotel_id=localStorage.getItem('hotel_id')

    const response = yield call(api.delete, `/tables/${id}?hotel_id=${hotel_id}`);
    if (response) {
      yield put(deleteTableSuccess(response.data));
    } else {
      yield put(deleteTableFailure(response.error || "Failed to delete table."));
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteTableFailure(error));
    toast.error("Failed to delete table.");
  }
}

function* putTableSaga(action) {
  try {
    const { id, data } = action.payload;
    const hotel_id=localStorage.getItem('hotel_id')

    const response = yield call(api.put, `/tables/${id}?hotel_id=${hotel_id}`, data);
    if (response) {
      yield put(updateTableSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(updateTableFailure(response.error || "Failed to update table."));
    }

  } catch (error) {
    yield put(updateTableFailure(error));
    toast.error("Failed to update table.");
  }
}

function* getByIDTableSaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(api.post, `/table/${id}`);
    if (response) {
      yield put(getByIdTableSuccess(response.data));
    } else {
      yield put(getByIdTableFailure(response.error || "Failed to get table."));
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getByIdTableFailure(error));
    // toast.error("Failed to get table.");
  }
}


export { deleteTableSaga, addTableSaga, getTableListSaga, putTableSaga, getByIDTableSaga }
